import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import strings_de from "./de/strings_de.json";
import strings_en from "./en/strings_en.json";
import { LANGUAGE_EN, LANGUAGE_DE } from '../constants/LANGUAGES';

i18n
    .use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: "en", // remove if we want german back
        resources: {
            en: strings_en,
            de: strings_de
        },
        supportedLngs: [LANGUAGE_EN, LANGUAGE_DE],
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
